<template>
  <div>
    <Breadcrumb :title="'Buyout Report'"></Breadcrumb>
    <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolBar @buttonClicked="toolbarOnClick"></BaseToolBar>
    <BaseGrid
      @InfoItem="gotoBuyoutDetails"
      :excelExport="excelExport"
      :mode="'editform'"
      :config="PartnerGridConfig"
      :data="PartnerGridData"
      @AttachItem="BuyoutAttachment"
    ></BaseGrid>
    <BuyoutDocumentDropoffForm
      ref="buyoutDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedBuyout"
    ></BuyoutDocumentDropoffForm>
  </div>
</template>

<script>
import $ from "jquery";
import { PartnerGridConfig } from "./BuyoutReportConfig.js";

import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import BaseBusinessEventRunningTotal from "@/models/BaseBusinessEventRunningTotal.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import BuyoutDocumentDropoffForm from "@/components/forms/BuyoutDocumentDropoffForm.vue";

export default {
  name: "BuyoutReport",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    BuyoutDocumentDropoffForm
  },
  data: function() {
    return {
      PartnerGridConfig: PartnerGridConfig,
      gridId: PartnerGridConfig.grid.gridId,
      search: {
        SearchData: ""
      },
      BuyoutMasterData: [],
      PartnerGridData: [],

      BaseModelPartner: BaseModelPartner,
      BaseBusinessEventRunningTotal: BaseBusinessEventRunningTotal,
      PartnerAPIData: [],
      BusinessEventRunningTotalAPIData: [],
      // Document dropoff modal
      docModalConfig: {
        modalName: "Buyout Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedBuyout: {}
    };
  },

  computed: {
    ...mapGetters("getModule", ["withFilter", "getAllItemFilter"])
  },

  mounted() {
    const self = this;
    // self._loadGridSettings(self.gridId);

    var grid = $("#reportBuyoutPartnerGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateBuyoutMasterData);

    self.getBaseGridData();
  },

  methods: {
    ...mapActions("getModule", ["AddCollection"]),

    async getBaseGridData() {
      const self = this;
      await self.getPartnerData();
      self._loadGridSettings(self.gridId);
    },

    gotoBuyoutDetails: function(e) {
      const gview = $("#reportBuyoutPartnerGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      this.AddCollection({
        key: "BuyoutTerminationDate",
        value: dataItem.LeaveDate
      });
      this.$router.push("/report/buyout/" + dataItem.Id);
    },

    filterGrid() {
      const self = this;
      const currentMasterdata = self.BuyoutMasterData;
      const filteredData = this._filterGrid(
        self.BuyoutMasterData,
        self.search.SearchData
      );
      $("#reportBuyoutPartnerGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      self.UpdateBuyoutMasterData(true, currentMasterdata);
    },

    UpdateBuyoutMasterData: function(fromFilter, filterMasterData) {
      const self = this;
      if (fromFilter == true) {
        self.BuyoutMasterData = filterMasterData;
      } else {
        self.BuyoutMasterData = $("#reportBuyoutPartnerGrid")
          .data()
          .kendoGrid.dataSource.data();
      }
    },

    toolbarOnClick: function(e) {
      const self = this;
      e.preventDefault();

      var headerList =[{}];
      var fileName = "Buyout Summary Report.xlsx";
      var arguementList={
        ...arguments,
        fileName:fileName,

        headers:headerList
      }


      this._baseToolBarEvents(self.gridId, arguementList);
    },

    async getPartnerData() {
      const self = this;

      let bundleObject = {
        Partner: {
          config: self.BaseModelPartner
        },
        BusinessEventRunningTotal: {
          config: BaseBusinessEventRunningTotal
        }
      };

      let response = this.getAllItemFilter(bundleObject);

      self.PartnerAPIData = response.Partner;
      self.BusinessEventRunningTotalAPIData =
        response.BusinessEventRunningTotal;
      console.log(` .... PartnerAPIData`,self.PartnerAPIData);
      let formerPartner = await _.filter(self.PartnerAPIData, function(obj) {
        return obj.BoughtOut == "Yes" && obj.PartnerStatus == "Former Employee";
      });
      console.log(` .... formerPartner`,formerPartner);
      
      // console.log("partnerData", formerPartner)

      let uniquePartnerId = _.uniq(
        _.map(self.BusinessEventRunningTotalAPIData, "PartnerId")
      );
      console.log(` .... uniquePartnerId`, uniquePartnerId);
  
      // console.log("uniquepartnerData", uniquePartnerId)

      self.PartnerGridData = [];
      for (let i = 0; i < uniquePartnerId.length; i++) {
        let result = _.filter(formerPartner, function(obj) {
          return (
            obj.Id.toString()
              .trim()
              .toLowerCase() ==
            uniquePartnerId[i]
              .toString()
              .trim()
              .toLowerCase()
          );
        })[0];

        if (result) {
          let gridData = {};
          gridData.Id = result.Id;
          gridData.PartnerID = result.PartnerID;
          gridData.PartnerName = result.FullName;
          gridData.PartnerStatus = result.PartnerStatus;
          gridData.LeaveDate = result.LeaveDate;

          self.PartnerGridData.push(gridData);
        }
      }
    },
    BuyoutAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#reportBuyoutPartnerGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedBuyout = { ...dataItem };

      (this.selectedBuyout.PartnerTitle = dataItem.PartnerName),
        (this.selectedBuyout.PartnerId = dataItem.Id);
      this.selectedBuyout.ProgramTitle = null;
      this.selectedBuyout.ProgramId = null;
      this.selectedBuyout.TransactionID = null;
      this.selectedBuyout.BusinessEvent = "Buyout";

      this.filterCondition.filter = `BusinessEvent eq 'Buyout' and PartnerId eq ${dataItem.Id}`;

      this.$refs.buyoutDocument.$refs.buyoutDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    }
  }
};
</script>
